import React from 'react'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar';
import { VariableSuppliers } from './VariableSuppliers';

function FilterSupplier({ translate }) {
    const { dispatch,langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad } = VariableSuppliers();
    const Filter = (e) => {
        e.preventDefault()
        
    }
    return (
        <div className='filteruser shadow_main margin_main' dir={langLocal=== 'ar' ? "rtl" : "ltr"}>
            <h3>{translate('search_filter')}</h3>
            <div className='div_filter' >
                <input className={`input_filter ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} placeholder={translate('first_name')} onChange={(e) => setStateCustom('first_name', e.target.value)} />
                <input className={`input_filter ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} placeholder={translate('last_name')} onChange={(e) => setStateCustom('last_name', e.target.value)} />
                <input className={`input_filter ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} placeholder={translate('email')} onChange={(e) => setStateCustom('email', e.target.value)} />
                <button className='btn_filter' onClick={Filter} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterSupplier